var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 111.61 107.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    x1: 311.92,
    y1: 304.08,
    x2: 285.63,
    y2: 271.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0532c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42127"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-2",
    x1: 305.38,
    y1: 312.18,
    x2: 268.12,
    y2: 366.35,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-3",
    x1: 23.34,
    y1: 24.53,
    x2: 98.7,
    y2: 76.56,
    xlinkHref: "#GradientFill_1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M338.58,296.47a53.81,53.81,0,0,1-63.39,84l12.48-15.92a39.15,39.15,0,0,0,15.76,3.29c22.16,0,40.12-18.37,40.12-41.05a41.45,41.45,0,0,0-9.36-26.34l4.39-4Zm-87.64,61.46a53.81,53.81,0,0,1,9.7-65l.87.76q4.88,4.26,9.69,8.59l0,0A41.89,41.89,0,0,0,266.54,343Z",
    transform: "translate(-244.14 -277.84)",
    style: {
      fill: "#03006d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.61,292.67a42.45,42.45,0,0,0-8.49-4.33l1.48-6a53.35,53.35,0,0,1,10.58,6.12l.07,0,3.16,2.33-4,3.62a12,12,0,0,0-2.65-1.61l-.2-.2Zm-41.47-2.26a40,40,0,0,0-8.58,6l-.26.24q-4.86-4.36-9.76-8.65a53.19,53.19,0,0,1,13.95-7.19l4.65,9.6ZM312,286.56a39.21,39.21,0,0,0-8.53-.79A40.58,40.58,0,0,0,290.84,288l-4.12-8.89a52.52,52.52,0,0,1,26.66,1.06Z",
    transform: "translate(-244.14 -277.84)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,376.41l65.45-85.55L256.17,364.3A40.77,40.77,0,0,0,268,376.41Z",
    transform: "translate(-244.14 -277.84)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.69 59.56 111.61 99.17 71.62 52.76 22.03 9.93 64.69 59.56",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1-3)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo_main.ef8493c168fbf8779deee5286badc51a.svg";
export { ForwardRef as ReactComponent };